import { Link } from 'react-router-dom'
import './Home.css'
import bannerRiverRocks from '../assets/bannerRiverRocks.webp'
import portraitCoffeeMachineMentorship from '../assets/portraitCoffeeMachineMentorship.webp'
import portraitEyesClosedPrayerBoysCouch from '../assets/PortraitEyesClosedPrayerBoysCouch.webp'
import portraitActionShotTableTennis from '../assets/portraitActionShotTableTennis.webp'
import portraitTableTennis from '../assets/portraitTableTennis.webp'
import bannerLakeWater from '../assets/bannerLakeWater.webp'

function Home() {
  return (
    <div className="home-page">
      <div className="row row-1">
        <div className="col col-1-2 banner">
          <h1 className="headerQuote">Nau mai, haere mai ki Taha Wairua</h1>
          <img
            src={bannerRiverRocks}
            alt="River and rocks banner"
            className="banner-image"
            id="topBanner"
          />
        </div>
      </div>

      <div className="row row-2 topRow">
        <div className="col col-1 text-col">
          <div className="text-container">
            <h2 className="content-heading">A Place To Belong</h2>
            <p className="content-paragraph">
              A warm, after-school space where rangatahi feel seen, safe, and
              welcome. ...{' '}
              <Link to="/about-us" className="content-inline-link">
                Read more.
              </Link>
            </p>
          </div>
        </div>
        <div className="col col-2 image-col">
          <img
            src={portraitCoffeeMachineMentorship}
            alt="Coffee machine mentorship"
            className="content-image"
          />
        </div>
      </div>

      <div className="row row-3">
        <div className="col col-1 image-col">
          <img
            src={portraitEyesClosedPrayerBoysCouch}
            alt="Eyes closed prayer boys on couch"
            className="content-image"
          />
        </div>
        <div className="col col-2 text-col">
          <div className="text-container">
            <h2 className="content-heading">Gentle Wairua</h2>
            <p className="content-paragraph">
              Short, opt-in spiritual practices that calm the mind and lift the
              heart.
            </p>
          </div>
        </div>
      </div>

      <div className="row row-4">
        <div className="col col-1 text-col">
          <div className="text-container">
            <h2 className="content-heading">Whanau & School Partnership</h2>
            <p className="content-paragraph">
              Local churches partnering with neighbourhood schools to serve
              young people well.
            </p>
          </div>
        </div>
        <div className="col col-2 image-col">
          <img
            src={portraitActionShotTableTennis}
            alt="Action shot table tennis"
            className="content-image"
          />
        </div>
      </div>

      <div className="row row-5">
        <div className="col col-1 image-col">
          <img
            src={portraitTableTennis}
            alt="Table tennis portrait"
            className="content-image"
          />
        </div>
        <div className="col col-2 text-col">
          <div className="text-container">
            <h2 className="content-heading">Safe & Supportive</h2>
            <p className="content-paragraph">
              Trained, police-vetted leaders who listen, encourage, and champion
              young people.
            </p>
          </div>
        </div>
      </div>

      <div className="row row-6">
        <div className="col col-1-2 banner">
          <img
            src={bannerLakeWater}
            alt="Lake water banner"
            className="banner-image"
          />
        </div>
      </div>
    </div>
  )
}

export default Home
